import { render, staticRenderFns } from "./FollowModel.vue?vue&type=template&id=916804d2&scoped=true&"
import script from "./FollowModel.vue?vue&type=script&lang=ts&"
export * from "./FollowModel.vue?vue&type=script&lang=ts&"
import style0 from "./FollowModel.vue?vue&type=style&index=0&id=916804d2&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "916804d2",
  null
  
)

export default component.exports